<template>
  <v-container>
    <v-app-bar app color="blue" dark>
      <!-- <v-app-bar-nav-icon @click.stop="drawerLeft = !drawerLeft" /> -->

      <v-toolbar-title>Sales Dashboard</v-toolbar-title>

      <v-spacer />

      <v-btn @click.stop="drawerRight = !drawerRight" icon>
        <v-icon large>mdi-account-circle</v-icon>
      </v-btn>
    </v-app-bar>

    <!-- <v-navigation-drawer v-model="drawerLeft" app floating temporary dark class="drawer-style">
      <v-list dense>
        <v-list-item link>
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title>Sales Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link>
          <v-list-item-action>
            <v-icon>mdi-information</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Info...</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>-->

    <v-navigation-drawer
      v-model="drawerRight"
      app
      right
      floating
      temporary
      dark
      class="drawer-style"
    >
      <v-list dense>
        <v-list-item link>
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title @click="logoutBtnClicked">Abmelden</v-list-item-title>
            <!-- <v-list-item-title @click="salesDataClicked">Sales Dashboard</v-list-item-title> -->
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
export default {
  name: "theHeader",

  data: function() {
    return {
      drawerLeft: null,
      drawerRight: null
    };
  },

  methods: {
    logoutBtnClicked: function() {
      if (localStorage.getItem("jwt") != null) {
        delete localStorage.jwt;
        this.$router.push("/login");
      }
    }
  }
};
</script>

<style scoped>
.drawer-style {
  background-color: #080808d0 !important;
}
</style>  